import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const ca: AppStrings = {
  // COMMON
  error_title: 'Error',
  cancel: 'Cancel·lar',
  retry: 'Tornar a intentar',
  back_arrow: '← Enrere',

  // ASK SCREEN
  ask_box_unavailable: 'Bústia no disponible',
  ask_box_unavailable_desc: "L'enllaç pot estar caducat o el propietari ha tancat la bústia.",
  ask_create_own_box: 'Crea la teva pròpia bústia',
  ask_sent_title: 'Enviat ✅',
  ask_sent_desc: 'La teva pregunta anònima ha estat lliurada al propietari de la bústia.',
  ask_anonymous_hint: 'La teva pregunta s\'enviarà de forma anònima.',
  ask_placeholder: 'Escriu la teva pregunta…',
  ask_send: 'Enviar',
  ask_sending: 'Enviant…',
  ask_error_rate_limit: 'Massa sol·licituds — espera un minut.',
  ask_error_restart: 'Reinicia la Mini App.',
  ask_error_load: 'No s\'ha pogut carregar la bústia.',
  ask_error_send: 'No s\'ha pogut enviar la pregunta.',
  ask_error_banned: 'Estàs bloquejat a l\'aplicació.',
  ask_banned_appeal_btn: 'Apel·lar',
  ask_appeal_sent: 'Apel·lació enviada. La revisarem manualment.',

  // AGE GATE
  age_gate_title: 'Només per a majors de 18',
  age_gate_desc:
    'Estàs enviant una pregunta anònima. Sigues respectuós: l\'assetjament, les amenaces, el contingut sexual amb menors i qualsevol contingut que violi la llei estan prohibits. L\'anonimat no significa impunitat — les infraccions es comuniquen a la moderació. En enviar una pregunta confirmes que tens 18 anys o més i acceptes les normes.',
  age_gate_confirm: 'Tinc 18+ — continuar',

  // INBOX SCREEN
  inbox_title: 'La teva bústia',
  box_link_accordion: 'Enllaç d\'invitació',
  inbox_notifications_ask: '🔔 Permet que el bot t\'enviï notificacions de noves preguntes?',
  inbox_notifications_allow: 'Permetre',
  inbox_notifications_dismiss_label: 'Tancar',
  inbox_box_toggle_disable: 'Desactivar preguntes',
  inbox_box_toggle_enable: 'Activar preguntes',
  inbox_box_disabled_warning: 'Les preguntes estan desactivades — no s\'acceptaran noves preguntes.',
  inbox_share_hint: 'Comparteix l\'enllaç perquè els teus amics et puguin fer preguntes anònimes.',
  inbox_copy: 'Copiar',
  inbox_copied: 'Copiat',
  inbox_copy_error: 'Error',
  inbox_no_deeplink: "L'enllaç apareixerà després del deploy.",
  inbox_invite_story: 'Convidar per Story',
  inbox_invite_chat: 'Convidar per xat',
  inbox_card_rendering: 'La targeta d\'invitació s\'està generant.',
  inbox_story_unsupported:
    'Les Stories no estan disponibles en aquesta versió de Telegram. Prova "per xat".',
  inbox_story_error: 'No s\'ha pogut obrir la Story.',
  inbox_chat_unsupported:
    'El compartiment per xat no està disponible en aquesta versió de Telegram. Actualitza el client.',
  inbox_chat_error: 'No s\'ha pogut compartir. Torna a intentar-ho.',
  inbox_chat_prepare_error: 'No s\'ha pogut preparar la invitació.',
  inbox_filter_incoming: 'Entrants',
  inbox_filter_hidden: 'Amagats',
  inbox_filter_blocked: 'Bloquejats',
  inbox_filter_empty: 'Aquí no hi ha res encara.',
  inbox_acc_unanswered: 'Sense resposta',
  inbox_acc_answered: 'Respostes',
  inbox_acc_hidden: 'Amagats',
  inbox_acc_blocked: 'Bloquejats',
  inbox_empty: 'Encara no hi ha preguntes. Comparteix l\'enllaç de dalt.',
  inbox_load_more: 'Carregar més',
  inbox_load_more_error: 'No s\'ha pogut carregar la pàgina següent.',
  inbox_error_load: 'No s\'ha pogut carregar la bústia.',
  inbox_rate_limit: 'Massa sol·licituds — espera un minut.',
  inbox_toggle_error: 'No s\'ha pogut canviar l\'estat de la bústia.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Escriu-me de forma anònima',
  message_placeholder: 'Escriu un missatge…',
  message_anonymous_hint: 'El teu missatge s\'enviarà de forma anònima.',
  message_sent_title: 'Enviat ✅',
  message_sent_desc: 'El teu missatge anònim ha estat lliurat.',
  message_owner_entry: 'Escriu-me',
  message_share_hint: 'Comparteix l\'enllaç perquè qualsevol et pugui enviar un missatge anònim.',
  message_inbox_open: 'Missatges rebuts',
  message_inbox_title: 'Missatges',
  message_inbox_empty: 'Encara no hi ha missatges. Comparteix el teu enllaç de dalt.',

  // ANSWER SCREEN
  answer_title: 'Respon la pregunta',
  answer_placeholder: 'Escriu la teva resposta…',
  answer_submit: 'Enviar',
  answer_submitting: 'Enviant…',
  answer_back: 'Enrere',
  answer_error_send: 'No s\'ha pogut enviar la resposta.',

  // SHARE SCREEN
  share_title: 'Resposta publicada ✅',
  share_hint: 'Comparteix la targeta i rep encara més preguntes.',
  share_card_rendering_desc:
    'La targeta s\'està generant. Torna a les preguntes i comprova-ho en breu — podràs compartir-la en una Story o xat.',
  share_card_alt: 'Targeta de resposta',
  share_story_btn: 'Compartir a Story',
  share_story_btn_busy: 'Obrint…',
  share_chat_btn: 'Compartir al xat',
  share_chat_btn_busy: 'Preparant…',
  share_back: 'Tornar a les preguntes',
  share_story_unsupported:
    'Les Stories no estan disponibles en aquesta versió de Telegram. Prova "Compartir al xat".',
  share_story_error: 'No s\'ha pogut obrir la Story. Prova "Compartir al xat".',
  share_chat_sent: 'Missatge enviat.',
  share_chat_unsupported:
    'El compartiment per xat no està disponible en aquesta versió de Telegram. Actualitza el client.',
  share_chat_error: 'No s\'ha pogut compartir. Torna a intentar-ho.',
  share_chat_prepare_error: 'No s\'ha pogut preparar el missatge.',

  // LEADERBOARD SCREEN
  lb_title: 'Classificació',
  lb_period_7d: '7 dies',
  lb_period_30d: '30 dies',
  lb_period_all: 'Tot el temps',
  lb_group_label: 'Categoria',
  lb_group_all: 'Tots',
  lb_group_ask: 'Preguntes',
  lb_group_rate: 'Valoració',
  lb_group_confession: 'Confessió',
  lb_group_guesswho: 'Endevina qui',
  lb_group_message: 'Missatges',
  lb_error: 'No s\'ha pogut carregar la classificació',
  lb_empty: 'Ningú a la classificació encara',
  lb_anon: 'Anònim',
  lb_load_more: 'Carregar més',
  lb_questions: (n) => plural('ca', n, { one: '{n} pregunta', other: '{n} preguntes' }),
  lb_referrals: (n) => plural('ca', n, { one: '{n} ref.', other: '{n} refs.' }),

  // REWARDS SCREEN
  rw_title: 'Les meves recompenses',
  rw_error: 'No s\'han pogut carregar les recompenses',
  rw_level: (n) => `Nivell ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('ca', n, { one: '{n} referència confirmada', other: '{n} referències confirmades' }),
  rw_next_level_section: (n) =>
    plural('ca', n, { one: 'NIVELL SEGÜENT — {n} referència', other: 'NIVELL SEGÜENT — {n} referències' }),
  rw_to_level: (level, target) => `fins al nivell ${level}: ${target}`,
  rw_max_level: 'Nivell màxim assolit!',
  rw_badges_section: 'INSÍGNIES',
  rw_formats_section: 'FORMATS DE BÚSTIA',

  // QUESTION CARD
  qcard_status_new: 'Nova',
  qcard_status_hidden: 'Amagada',
  qcard_status_answered: 'Respost',
  qcard_moderation_flagged: 'Atenció: missatge sospitós',
  qcard_answer_btn: 'Respondre',
  qcard_answer_send: 'Enviar',
  qcard_share_btn: 'Compartir',
  qcard_hide_btn: 'Amagar',
  qcard_show_btn: 'Mostrar',
  qcard_report_btn: 'Denunciar',
  qcard_block_btn: 'Bloquejar',
  qcard_unblock_btn: 'Desbloquejar',
  qcard_report_reason_label: 'Selecciona el motiu de la denúncia:',
  qcard_reason_spam: 'Correu brossa',
  qcard_reason_harassment: 'Assetjament',
  qcard_reason_sexual: 'Contingut sexual',
  qcard_reason_other: 'Altre',
  qcard_error_hide: 'No s\'ha pogut canviar la visibilitat.',
  qcard_error_report: 'No s\'ha pogut enviar la denúncia.',
  qcard_error_block: 'No s\'ha pogut bloquejar el remitent.',
  qcard_report_done: 'Denúncia enviada — gràcies.',
  qcard_block_done: 'Remitent bloquejat.',
  qcard_unblock_done: 'Remitent desbloquejat.',

  // ERRORS (common humanized error messages)
  err_network: 'Sense connexió al servidor. Comprova la teva internet i torna-ho a intentar.',
  err_server_unavailable: 'El servidor no està disponible temporalment, torna-ho a intentar més tard.',
  err_internal: 'Alguna cosa ha anat malament. Ja hi estem mirant — torna-ho a intentar més tard.',
  err_bad_request: 'Comprova les dades introduïdes.',
  err_generic: 'No s\'ha pogut completar l\'acció, torna-ho a intentar més tard.',
  err_schema: 'Error de dades. Prova d\'actualitzar l\'aplicació.',
  share_story_link_premium_note:
    'Un enllaç clicable a Stories requereix Telegram Premium. Sense ell els teus amics encara et podran trobar — el teu nom d\'usuari apareix a la targeta.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Error d\'accés',
  auth_error_desc:
    'No s\'ha pogut autenticar. Tanca la Mini App i torna-la a obrir des de Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Nova recompensa!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Preguntes',
  tab_leaderboard: 'Classificació',
  tab_rewards: 'Recompenses',
  tab_settings: 'Configuració',

  // SETTINGS SCREEN
  settings_title: 'Configuració',
  settings_section_general: 'General',
  settings_notifications: 'Notificacions de noves preguntes',
  settings_notifications_hint: 'El bot t\'enviarà un missatge quan algú faci una pregunta.',
  settings_notifications_error: 'No s\'ha pogut desar la configuració de notificacions.',
  settings_language: 'Idioma',
  settings_language_error: 'No s\'ha pogut canviar l\'idioma. Torna-ho a intentar.',
  settings_section_about: 'Sobre l\'aplicació',
  settings_version: 'Versió',

  // CODE ENTRY (work-020)
  code_modal_title: 'Els enllaços de Story són exclusius per a Premium',
  code_modal_explain:
    'Telegram només dona un enllaç clicable de story als subscriptors Premium. En lloc d\'això, afegeix el teu codi a la story — els espectadors l\'escriuen a l\'aplicació i et fan una pregunta anònima.',
  code_modal_your_code: 'El teu codi',
  code_modal_copy: 'Copiar codi',
  code_modal_copied: 'Copiat',
  code_modal_share_btn: 'Compartir a story',
  code_modal_loading: 'Obtenint el teu codi…',
  code_modal_error: 'No s\'ha pogut obtenir el teu codi. Torna-ho a intentar més tard.',
  ask_code_title: 'Introdueix un codi',
  ask_code_desc:
    'Has vingut d\'una story? Troba el codi (per exemple, 1234) i escriu-lo a continuació.',
  ask_code_placeholder: 'Codi de la story',
  ask_code_find: 'Trobar',
  ask_code_not_found: 'Codi no trobat. Comprova els dígits i torna-ho a intentar.',
  ask_code_invalid: 'El codi és de 4 dígits.',
  code_onboarding_header: 'Has vingut d\'una story?',
  code_onboarding_text: 'Introdueix el codi d\'un amic per fer-li una pregunta anònima.',
  code_onboarding_action: 'Introduir codi',
  settings_ask_by_code: 'Preguntar per codi',
  settings_my_code_title: 'El teu codi de story',
  settings_my_code_hint:
    'Escriu aquest codi a la teva story — els espectadors l\'escriuen per fer-te una pregunta anònima. Telegram només dona enllaços clicables de story als subscriptors Premium.',
  settings_my_code_rotate: 'Obtenir un nou codi',
  settings_my_code_rotating: 'Actualitzant…',
  settings_my_code_done: 'Codi actualitzat',
  settings_my_code_error: 'No s\'ha pogut obtenir el teu codi.',
  settings_my_code_rotate_confirm_title: 'Canviar el codi?',
  settings_my_code_rotate_confirm_desc:
    'El teu codi antic deixa de funcionar a l\'instant. Ningú que l\'hagi vist a la teva story no podrà contactar amb tu. Canvia\'l només si algú t\'està enviant spam.',
  settings_my_code_rotate_confirm_action: 'Canviar el codi',

  // BOT
  bot_greeting: (name) => (name ? `Hola, ${name}! 👋` : 'Hola! 👋'),
  bot_onboarding:
    'Això és VeylMe — preguntes anònimes.\n\n' +
    'Obre la Mini App, publica una targeta «Pregunta\'m anònimament» a la teva Story — ' +
    'i rep preguntes anònimes aquí mateix.\n\n' +
    '⚠️ 18+. Sigues respectuós: l\'assetjament, les amenaces i el contingut prohibit ' +
    'no estan permesos. Anonimat ≠ impunitat — les infraccions van a moderació.',
  bot_open_btn: 'Obrir VeylMe',
  notify_answer_btn: 'Respondre',
  bot_invite_text:
    'Algú ha compartit un enllaç de VeylMe.\n\n' +
    'Obre la Mini App per fer una pregunta anònima:',
  bot_invite_btn: 'Preguntar anònimament',

  // WORK-027 i18n sweep
  tagline: 'Pregunta\'m de forma anònima',
  share_ask_action: 'Preguntar',
  share_answered_text: 'He respost una pregunta anònima 👀',
  err_not_in_telegram: 'La Mini App no s\'està executant a Telegram. Reinicia l\'aplicació.',
  badge_viral_starter: 'Inici viral',
  badge_storyteller: 'Narrador',
  badge_loop_master: 'Mestre del cicle',
  theme_confession: 'Confessions',
  theme_guesswho: 'Endevina qui',
  rw_format_named: (name) => `format «${name}»`,
  card_label_question: 'Pregunta',
  card_label_answer: 'Resposta',
  card_invite_subtitle: 'anònim, sense registre',
  card_code_hint: 'INTRODUEIX EL CODI A L\'APLICACIÓ',
  share_msg_title: (brand) => `${brand} · Preguntes anònimes`,
  notify_new_question: '🔔 Algú t\'ha fet una pregunta anònima',
  notify_unanswered_reminder: (n) =>
    plural('ca', n, { one: '🔔 Tens {n} pregunta sense respondre', other: '🔔 Tens {n} preguntes sense respondre' }),
  notify_ban_permanent: 'permanentment',
  notify_ban_until: (date) => `fins al ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Estàs bloquejat a VeylMe ${untilPhrase}. Massa destinataris han denunciat els teus missatges.\nSi creus que és un error, pots presentar una apel·lació a l'aplicació.`,
  notify_warning_msg:
    '⚠️ Diversos destinataris han denunciat els teus missatges. Una mica més i seràs bloquejat a VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Les meves preguntes',
  my_questions_empty_title: 'Encara no has fet cap pregunta',
  my_questions_empty_desc: 'Fes una pregunta a la bústia d\'algú — la resposta apareixerà aquí.',
  my_questions_loading: 'Comprovant si hi ha resposta…',
  my_questions_waiting: 'Esperant resposta',
  my_questions_answer_label: 'Resposta',
  settings_my_questions: 'Les meves preguntes',
  ask_sent_find_reply_hint: 'Podràs trobar la resposta més tard a «Les meves preguntes».',
  inbox_story_nonpremium_hint: 'L\'enllaç a la Story no és clicable sense Telegram Premium, per això mostrem un codi — compartir al xat és més fiable.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'El teu accés de Telegram ha caducat',
  session_expired_desc: 'Telegram dóna accés a l\'app només un cop, en obrir-la, i aquest ja ha caducat. Obre l\'app de nou — hem desat el text que havies començat.',
  session_expired_desc_no_storage: 'El passi de Telegram ha caducat i cal tornar a obrir l\'app. No hem pogut desar el text que havies escrit — copia\'l abans de sortir.',
  session_expired_reopen: 'Obrir de nou',
  session_expired_stuck_title: 'Telegram ha tornat el mateix accés antic',
  session_expired_stuck_desc: 'Tanca l\'app del tot des del menú del bot i torna-la a obrir — llavors Telegram donarà un accés nou.',
  session_auth_failed_title: 'No s\'ha pogut confirmar l\'accés',
  session_auth_failed_desc: 'Telegram no ha confirmat el teu accés a l\'app. Tanca l\'app i torna a obrir-la des del xat amb el bot.',
  session_expired_manual_close: 'L\'app no es pot tancar sola des d\'aquí — tanca-la tu i torna a obrir-la des del xat amb el bot.',
  session_expiring_soon: 'El teu accés de Telegram caducarà aviat. Obre l\'app de nou perquè no es perdi res.',
  my_questions_check_failed: 'No s\'han pogut comprovar les respostes. Torna-ho a provar més tard.',
  settings_notifications_load_error: 'No s\'ha pogut carregar l\'opció.',
};
